/* ---------------------------------------------------------------------------
importするapiを記述（共通）
---------------------------------------------------------------------------- */
import * as Auth from "@/api/common/Auth.js";
import * as Password from "@/api/common/Password.js";
/* ---------------------------------------------------------------------------
importするapiを記述（KIZUNA）
---------------------------------------------------------------------------- */

/* ---------------------------------------------------------------------------
importするapiを記述（特定技能）
---------------------------------------------------------------------------- */

/* ---------------------------------------------------------------------------
importするapiを記述（営業）
---------------------------------------------------------------------------- */
import * as Company from "@/api/sales/Company.js";
import * as SupportLog from "@/api/sales/SupportLog.js";

/* ---------------------------------------------------------------------------
上記でimportしたapiを読み込む
vue側ではこのfunctionApi.jsをimportしてapiを呼び出します。

vue側での呼び出し方
	import functionApi from "@/api/FunctionApi.js";
	const functionApi = new functionApi();
	↑ newすることで、functionApiに設定されているメソッドが利用できる
	例）functionApi.account.get();
---------------------------------------------------------------------------- */
export default class FunctionApi {
	constructor() {}

	// ログインAPI
	get auth() {
		return Auth;
	}

	// パスワードAPI
	get password() {
		return Password;
	}
	/* ---------------------------------------------------------------------------
KIZUNA
---------------------------------------------------------------------------- */

	/* ---------------------------------------------------------------------------
KIZUNA 特定技能
---------------------------------------------------------------------------- */

	/* ---------------------------------------------------------------------------
営業
---------------------------------------------------------------------------- */
	// 顧客管理API
	get company() {
		return Company;
	}

	// 応対履歴API
	get supportLog() {
		return SupportLog;
	}
}
